import React from 'react';
import PropTypes from 'prop-types';
import { PROBE_DETAIL } from '../../constants/reading/ProbeDetailsConstants';

const TransitionWrapper = ({
    transitionState,
    onCloseWrappedComponent,
    WrappedComponent,
    wrapperProps,
    className,
    isGuidedTourOn,
}) => {
    return (
        <>
            <div
                data-tour-step={PROBE_DETAIL}
                id={PROBE_DETAIL}
                className={`${className} ${transitionState}`}
            >
                <WrappedComponent
                    onCloseWrappedComponent={onCloseWrappedComponent}
                    {...wrapperProps}
                />
            </div>
            <div className={`shadow-layout ${isGuidedTourOn ? ' in-tour' : ''}`} />
        </>
    );
};
TransitionWrapper.defaultProps = {
    transitionState: '',
    onCloseWrappedComponent: () => {},
    WrappedComponent: <></>,
    wrapperProps: {},
    className: '',
    isGuidedTourOn: false,
};
TransitionWrapper.propTypes = {
    transitionState: PropTypes.string,
    onCloseWrappedComponent: PropTypes.func,
    WrappedComponent: PropTypes.func,
    wrapperProps: PropTypes.object,
    className: PropTypes.string,
    isGuidedTourOn: PropTypes.bool,
};

export default TransitionWrapper;
